<template>
  <!-- https://buefy.org/documentation/table#draggable-rows  -->
  <b-table
    :data="tableData"
    hoverable
    draggable
    @dragstart="dragstart"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <slot></slot>
  </b-table>
</template>

<script>
export default {
  name: "TableDraggable",
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      draggingRowIndex: null,
    }
  },
  methods: {
    dragstart (payload) {
      this.draggingRowIndex = payload.index;
    },
    dragover(payload) {
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.tableData.splice(payload.index, 0, ...this.tableData.splice(this.draggingRowIndex, 1));

      this.$emit('updated', this.tableData);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
